import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
	locales: ["pt-BR", "en-US"],
	defaultLocale: "pt-BR",
	localePrefix: "as-needed",
	localeDetection: false,
});

export type Locale = (typeof routing.locales)[number];
